export interface ToggleOptions {
  leftSide: string;
  rightSide: string;
}
